var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icomoon",class:[_vm.fixedWidthClass, _vm.iconClass, _vm.clickableClass, _vm.sizeClass, _vm.spinningClass],attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }